import { createContext, useContext } from "react";

export type ChatFileDropHandler = (files: File[]) => void;

/**
 * Lets the chat page's drop zone hand dropped files to the composer that owns
 * the upload modal. The composer registers one handler; the page zone stays
 * disabled while none is registered. Absent outside the chat page (the Polly
 * sheet renders the same composer), so callers skip registration there.
 */
export interface ChatFileDropContextValue {
    /** Returns the unregister function; unregistering removes only `handler`. */
    registerDropHandler: (handler: ChatFileDropHandler) => () => void;
}

export const ChatFileDropContext = createContext<
    ChatFileDropContextValue | undefined
>(undefined);

/** Undefined outside the chat page, so callers can degrade rather than throw. */
export function useChatFileDrop(): ChatFileDropContextValue | undefined {
    return useContext(ChatFileDropContext);
}
